/* Optional local face-box geometry. It neither detects faces nor changes order data. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.GIOPhotoCropAssist = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  function clamp(n, low, high) { return Math.max(low, Math.min(high, n)); }
  function validRect(r) { return !!r && ['x', 'y', 'width', 'height'].every(function (key) { return Number.isFinite(r[key]); }) && r.width > 0 && r.height > 0; }
  function copy(r) { return { x:r.x, y:r.y, width:r.width, height:r.height }; }
  function faces(values) {
    return (Array.isArray(values) ? values : []).slice(0, 32).filter(function (r) {
      return validRect(r) && r.x >= 0 && r.y >= 0 && r.x + r.width <= 1.000001 && r.y + r.height <= 1.000001;
    }).map(copy);
  }
  function rotateFaces(values, degrees) {
    var angle = ((Math.round((Number(degrees) || 0) / 90) * 90) % 360 + 360) % 360;
    return faces(values).map(function (r) {
      if (angle === 90) return { x:1-r.y-r.height, y:r.x, width:r.height, height:r.width };
      if (angle === 180) return { x:1-r.x-r.width, y:1-r.y-r.height, width:r.width, height:r.height };
      if (angle === 270) return { x:r.y, y:1-r.x-r.width, width:r.height, height:r.width };
      return r;
    });
  }
  // A face box does not describe the complete head. Leave extra room around it,
  // especially above it; this remains a visual suggestion, not a guarantee.
  function padded(r) {
    var left = r.x-r.width*.18, top = r.y-r.height*.45;
    var right = r.x+r.width*1.18, bottom = r.y+r.height*1.15;
    return { x:clamp(left,0,1), y:clamp(top,0,1), right:clamp(right,0,1), bottom:clamp(bottom,0,1), sourceEdge:left < 0 || top < 0 || right > 1 || bottom > 1 };
  }
  function risk(values, crop, degrees) {
    var detected = rotateFaces(values, degrees), count = 0, sourceEdge = false;
    if (!validRect(crop)) return { count:0, cropRisk:false, sourceEdge:false };
    detected.forEach(function (face) {
      var area = padded(face); sourceEdge = sourceEdge || area.sourceEdge;
      if (area.x < crop.x-1e-7 || area.y < crop.y-1e-7 || area.right > crop.x+crop.width+1e-7 || area.bottom > crop.y+crop.height+1e-7) count++;
    });
    return { count:count, cropRisk:count > 0, sourceEdge:sourceEdge };
  }
  function riskRegions(values, degrees) {
    return rotateFaces(values,degrees).map(function(face){var p=padded(face);return {x:p.x,y:p.y,width:p.right-p.x,height:p.bottom-p.y};});
  }
  function suggestCrop(values, crop, degrees) {
    if (!validRect(crop) || crop.x < 0 || crop.y < 0 || crop.x+crop.width > 1.000001 || crop.y+crop.height > 1.000001) return null;
    var detected = rotateFaces(values, degrees);
    if (!detected.length || !risk(values,crop,degrees).cropRisk) return null;
    var bounds = { x:1, y:1, right:0, bottom:0 };
    detected.forEach(function (face) { var p=padded(face); bounds.x=Math.min(bounds.x,p.x); bounds.y=Math.min(bounds.y,p.y); bounds.right=Math.max(bounds.right,p.right); bounds.bottom=Math.max(bounds.bottom,p.bottom); });
    // Keep the original zoom. If all faces cannot fit, ask the customer to use
    // Keep full photo instead of silently choosing one person's face.
    if (bounds.right-bounds.x > crop.width+1e-7 || bounds.bottom-bounds.y > crop.height+1e-7) return null;
    var x=clamp(crop.x,Math.max(0,bounds.right-crop.width),Math.min(1-crop.width,bounds.x));
    var y=clamp(crop.y,Math.max(0,bounds.bottom-crop.height),Math.min(1-crop.height,bounds.y));
    if (Math.abs(x-crop.x)<1e-7 && Math.abs(y-crop.y)<1e-7) return null;
    return { x:x, y:y, width:crop.width, height:crop.height };
  }
  function message(result, canContain) {
    if (result && result.cropRisk) return 'Part of a face may be outside the frame.';
    if (result && result.sourceEdge) return 'A face is close to the edge of the original photo.';
    return '';
  }
  return { rotateFaces:rotateFaces, riskRegions:riskRegions, suggestCrop:suggestCrop, risk:risk, message:message };
});
